import lodash_1 from "lodash";

const fontCircularBook = [
    'Circular Std Book Regular',
    'Arial Unicode MS Regular',
];
const textAllowOverlap = [
    'step', ['zoom'],
    false,
    21.3, true
];

const pinScale = 1.5;

const minZoomDimmedLabels = 15;
const textMaxWidth = 10;

const textHighlightedOpacity = [
    'interpolate', ['linear'], ['zoom'],
    minZoomDimmedLabels, 0,
    minZoomDimmedLabels + 0.1, 1,
];
const textDimmedOpacity = [
    'interpolate', ['linear'], ['zoom'],
    minZoomDimmedLabels, 0,
    minZoomDimmedLabels + 0.1, 0.5,
];
const textPaddingHighlighted = [
    'step', ['zoom'],
    20,
    19, 10
];
const textHaloWidthHighlighted = [
    'interpolate', ['linear'], ['zoom'],
    10, 10,
    19, 0.5,
];
const textTranslateHighlighted = () => [
    'interpolate', ['linear'], ['zoom'],
    18, ['literal', [0, -11]],
    20, ['literal', [0, -30]],
];
const iconOpacityHighlighted = [
    'interpolate', ['linear'], ['zoom'],
    minZoomDimmedLabels, 0,
    minZoomDimmedLabels + 0.1, 1,
    19, 0,
];
const textColor = (theme) => theme === 'light' ? 'hsl(234, 47%, 27%)' : '#ffffff';
const textHaloColor = (theme) => theme === 'light' ? '#FFFFFF' : '#242A65';
const minZoom = 15;

export const getVenueLabelsHighlightedLayer = (theme) => ({
    id: 'live_tiles_labels',
    type: 'symbol',
    source: 'live_tiles',
    'source-layer': 'live_tiles',
    minzoom: minZoom,
    layout: {
        'text-field': ['get', 'name'],
        'text-font': fontCircularBook,
        'text-anchor': 'left',
        'text-offset': [1.2, 0],
        'text-size': 15,
        'text-padding': textPaddingHighlighted,
        'text-max-width': textMaxWidth,
        'text-allow-overlap': textAllowOverlap,
    },
    paint: {
        'text-color': textColor(theme),
        'text-opacity': textHighlightedOpacity,
        'text-halo-color': textHaloColor(theme),
        'text-halo-width': textHaloWidthHighlighted,
        // 'text-translate': textTranslateHighlighted(),
        'icon-opacity': iconOpacityHighlighted,
    },
});
export const getVenueLabelsDimmedLayer = (theme) => ({
    id: 'live_tiles_labels',
    type: 'symbol',
    source: 'live_tiles',
    'source-layer': 'live_tiles',
    minzoom: minZoom,
    layout: {
        'text-field': ['get', 'name'],
        'text-font': fontCircularBook,
        'text-anchor': 'bottom',
        'text-size': 13,
        'text-padding': 5,
        'text-allow-overlap': textAllowOverlap,
    },
    paint: {
        'text-color': textColor(theme),
        'text-opacity': textDimmedOpacity,
        'text-halo-color': textHaloColor(theme),
        'text-halo-width': 2,
        'text-translate': [0, -16],
    },
});

export const getVenuePinsDefaultLayer = () => ({
    id: 'live_tiles',
    type: 'circle',
    source: 'live_tiles',
    'source-layer': 'live_tiles',
    paint: {
        'circle-radius': [
            'interpolate',
            ['linear'],
            ['zoom'],
            12, 1.5,   // at zoom 12 → radius 1.5
            14, 2,     // at zoom 14 → radius 2
            16, 3,     // at zoom 16 → radius 3
            18, 5      // at zoom 18 → radius 5
        ],
        'circle-color': ['get', 'color']
    },
});
const zoomStops = [0, 8, 12, 14, 18, 20];
// pin circle radius sizes
const radiiHighlighted = [0.194, 0.4, 1.25, 2, 4.5, 18];
const scaledRadiiHighlighted = (scale) => {
    // scale all but the last size (zoomed in) since it's large already
    let radii = [];
    for (let i = 0; i < radiiHighlighted.length - 1; i++) {
        radii.push(radiiHighlighted[i] * scale);
    }
    radii.push(radiiHighlighted[radiiHighlighted.length - 1]);
    return radii;
};
const highlightedCircleRadii = (scale) => lodash_1.flatten(lodash_1.zip(zoomStops, scaledRadiiHighlighted(scale)));

const pinHighlightedCircleRadius = (scale) => [
    'interpolate', ['linear'], ['zoom'],
    ...highlightedCircleRadii(scale)
];


const caseHasEvent = ['get', 'hasEvent'];
const pinBlurValues = [0.75, 0.75, 0.75, 0.5, 0.25, 0];
const pinBlurStops = lodash_1.flatten(lodash_1.zip(zoomStops, pinBlurValues.map(v => {
    return ['case', caseHasEvent, v * 0.8, v];
})));
// prettier-ignore
const pinCircleBlur = [
    'interpolate', ['linear'], ['zoom'], ...pinBlurStops,
];
const pinHighlightedCircleOpacity = [
    'interpolate', ['linear'], ['zoom'],
    11, 0.7,
    19, 1,
];
const halosHighlighted = [0, 0, 0.375, 0.75, 3.5, 5];
const pinCircleStrokeWidths = (widths) => {
    const interpolation = ['interpolate', ['linear'], ['zoom']];
    const cases = widths.map(w => ['case', caseHasEvent, w, 0]);
    return [...interpolation, ...lodash_1.flatten(lodash_1.zip(zoomStops, cases))];
};

export const getVenuePinsHighlightedLayer = () => ({
    id: 'live_tiles',
    type: 'circle',
    source: 'live_tiles',
    'source-layer': 'live_tiles',
    paint: {
        'circle-radius': pinHighlightedCircleRadius(pinScale),
        'circle-color': ['get', 'color'],
        'circle-blur': pinCircleBlur,
        'circle-opacity': pinHighlightedCircleOpacity,
        'circle-stroke-width': pinCircleStrokeWidths(halosHighlighted),
        'circle-stroke-color': ['get', 'color'],
        'circle-stroke-opacity': 0.8,
    },
});

const radiiDimmed = [0.16, 0.24, 0.49, 0.77, 1.94, 9];
const dimmedCircleRadii = lodash_1.flatten(lodash_1.zip(zoomStops, radiiDimmed));
const pinDimmedCircleRadius = [
    'interpolate', ['linear'], ['zoom'],
    ...lodash_1.flatten(dimmedCircleRadii),
];
const dimPinColor = (theme) => theme === 'light' ? '#A2A6AD' : '#6567A2';
const halosDimmed = [0, 0, 0.5, 0.7, 5, 8];
export const getVenuePinsDimmedLayer = (theme) => ({
    id: 'live_tiles',
    type: 'circle',
    source: 'live_tiles',
    'source-layer': 'live_tiles',
    paint: {
        'circle-radius': pinDimmedCircleRadius,
        'circle-color': dimPinColor(theme),
        'circle-stroke-width': pinCircleStrokeWidths(halosDimmed),
        'circle-stroke-color': dimPinColor(theme),
        'circle-stroke-opacity': 0.5,
    },
});